module.exports = __webpack_public_path__ + "gray-csv.0e380334f72af72583f9c118f84c87f9.png";